<template>
  <div class="app-main-inner" style="padding:5px 0;width: fit-content; min-width: 1000px; height: 100%;">
    <div class="app-main-inner-row section">
      <!--销售属性-->
      <div>
        <el-form label-width="120px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="24">
              <div style="display: flex">
                <div style="background-color: #57D1FF; width: 12px; height: 30px;margin-right: 5px" />
                <label style="font-width: bold; font-size: 15px;">{{ $t('CargoMsg.Cargo_NatureOfSales') }}</label>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Sales')">
                <el-input v-model="txtOwnerId" :disabled="true" no="1" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_BranchCompany')">
                <el-input v-model="txtBranchId" :disabled="true" no="2" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_OwningDept')">
                <el-input v-model="txtDepartment" :disabled="true" no="3" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_TeamLeader')">
                <el-input v-model="txtGroupLeader" :disabled="true" no="4" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_AssignmentDate')">
                <el-date-picker
                  v-model="quotationClient.assignDate"
                  :disabled="true"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  no="5"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_DaysOfSleep')">
                <el-input v-model="quotationClient.sleepDays" :disabled="true" no="6" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_DaysFromContractSigned')">
                <el-input v-model="quotationClient.signedDays" :disabled="true" no="7" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_DaysToContractExpiry')">
                <el-input v-model="quotationClient.dueTime2" :disabled="true" no="8" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--客户属性-->
      <div>
        <el-form label-width="120px" label-position="left" style="width: 1200px;">
          <el-row :gutter="10">
            <el-col :span="24">
              <div style="display: flex;">
                <div style="background-color: #57D1FF; width: 12px; height: 30px;margin-right: 5px;" />
                <label style="font-width: bold; font-size: 15px;">{{ $t('CargoMsg.Cargo_CustomerProperty') }}</label>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_ClientNo')">
                <el-input v-model="quotationClient.clientId" :disabled="true" no="9" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_ChineseName')" required>
                <el-input v-model="quotationClient.name" :disabled="!isEditing" style="width:240px" no="10" />
                <el-tooltip style="margin-left:5px;" effect="light" :content="$t('Partners.industrialAndCommercialInformationQuery')" placement="right-end">
                  <a :href="tianYanChaUrl" target="_blank" style="width: 20px;height: 20px;margin-bottom:5px;cursor: pointer;  vertical-align: middle; display: inline-block">
                    <img src="/static/eyeInTheSky.png" style="width: 20px;height: 20px;">
                  </a>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_EnglishName')" required>
                <el-input v-model="quotationClient.englishName" :disabled="!isEditing" no="11" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_Abbreviation')">
                <el-input v-model="quotationClient.shortName" :disabled="!isEditing" :maxlength="100" no="shortName" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div style="display: flex">
                <el-form-item :label="$t('CargoMsg.Cargo_ScaleOfCompany')">
                  <el-input-number v-model="quotationClient.companySize" :disabled="!isEditing" :min="1" :max="999999999999" :precision="0" controls-position="right" style="width: 100%" no="12" />
                </el-form-item>
                <span style="padding-left: 10px;">{{ $t('CargoMsg.Cargo_People') }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div style="display: flex;">
                <el-form-item :label="$t('CargoMsg.Cargo_RegisteredCapital')">
                  <div style="display: flex">
                    <el-input-number v-model="quotationClient.registeredCapital" :disabled="!isEditing" :min="1" :max="999999999999" controls-position="right" style="flex: 1;width: 100%" no="13" />
                    <span style="padding-left: 10px;font-size: 8px;">{{ $t('CargoMsg.Cargo_TenThousandYuan') }}</span>
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_CustomerType')">
                <el-select
                  v-model="quotationClient.companyTypeCode"
                  :disabled="!isEditing"
                  :placeholder="$t('SeaExport.PleaseSelect')"
                  size="mini"
                  no="14"
                >
                  <el-option
                    v-for="(item,index) in crmCustomerTypeList"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_ClientStatus')">
                <el-select
                  v-model="quotationClient.customerStatusCode"
                  :disabled="!(isEditing && parseInt(quotationClient.customerStatusCode) !== parseInt(CrmCustomerConstants.STAGE_COOPERATION.code))"
                  :placeholder="$t('SeaExport.PleaseSelect')"
                  size="mini"
                  no="15"
                >
                  <el-option
                    v-for="(item,index) in parseInt(quotationClient.customerStatusCode) === parseInt(CrmCustomerConstants.STAGE_COOPERATION.code) ? CrmCustomerConstants.CUSTOMER_STATUS : CrmCustomerConstants.CUSTOMER_STATUS_NO_COOPERATION"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_AssessedClientLevel')">
                <el-select
                  v-model="quotationClient.customerLevelCode"
                  :disabled="!isEditing"
                  :placeholder="$t('SeaExport.PleaseSelect')"
                  size="mini"
                  no="16"
                >
                  <el-option
                    v-for="(item,index) in customerLevelCode"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_DifficultyIndex')">
                <el-select
                  v-model="quotationClient.overcomeLevelCode"
                  :disabled="!isEditing"
                  :placeholder="$t('SeaExport.PleaseSelect')"
                  size="mini"
                  no="17"
                >
                  <el-option
                    v-for="(item,index) in overcomeLevelCode"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item v-show="showSourceType" :label="$t('CargoMsg.Cargo_SourceOfClient')">
                <el-select
                  v-model="quotationClient.sourceType"
                  :disabled="true"
                  :placeholder="$t('CargoMsg.Cargo_SalesFreeHand')"
                  size="mini"
                  no="18"
                >
                  <el-option
                    v-for="(item,index) in CrmCustomerConstants.SOURCE_TYPE_GRID"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_Competitor')">
                <el-input v-model="quotationClient.competitorCompany" :disabled="!isEditing" no="21" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_CustomerContactChannel')">
                <el-select
                  v-model="quotationClient.customerContactChannel"
                  :disabled="!isEditing"
                  :placeholder="$t('SeaExport.PleaseSelect')"
                  size="mini"
                  no="19"
                >
                  <el-option
                    v-for="(item,index) in customerContactChannelList"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_FirstContactDate')" required>
                <el-date-picker
                  v-model="quotationClient.firstMeetDate"
                  :disabled="true"
                  type="date"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                  no="20"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--客户地址-->
      <div>
        <el-form label-width="120px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="24">
              <div style="display: flex;">
                <div style="background-color: #57D1FF; width: 12px; height: 30px;margin-right: 5px" />
                <label style="font-width: bold; font-size: 15px;">{{ $t('CargoMsg.Cargo_CustomerAddress') }}</label>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-form :inline="false" label-width="120px" label-position="left">
              <el-col :span="8">
                <el-form-item :label="$t('CargoMsg.Cargo_CountryRegion')">
                  <cargo-advance-select
                    :disabled="!isEditing"
                    filterable
                    :select-type="selectTypeNames.basic_data_Country"
                    :tag-name="$store.getters.language==='zh'?'chineseName':'name'"
                    :default-value="quotationClient.country"
                    no="22"
                    @parentCallBack="selectCargoItem"
                  />
                </el-form-item>
              </el-col>
            </el-form>
            <el-form :disabled="!isEditing" :inline="true" label-width="60px">
              <el-col :span="16">
                <cargo-area
                  filterable
                  :allow-create="false"
                  :country="quotationClient.country"
                  :province.sync="quotationClient.province"
                  :city.sync="quotationClient.city"
                  :district.sync="quotationClient.districts"
                  :select-width="120"
                  no="23"
                />
              </el-col>
            </el-form>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item :label="$t('CargoMsg.Cargo_StreetAddress')" required>
                <el-input v-model="quotationClient.address" :disabled="!isEditing" no="24" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input v-model="quotationClient.remarks" :disabled="!isEditing" type="textarea" :rows="4" no="25" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import { QuotationClient } from '@/class/model/sales/QuotationClient'
import { getCompanyByName } from '@/api/company'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getLoading } from '@/utils/utilBaseElement'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { getCacheListByKey, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import {
  getMyCustomerSelectType
} from '@/api/basicData/customerRating'

export default {
  name: 'TabCrmCustomer',
  components: {
    cargoAdvanceSelect,
    cargoArea
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    modelType: { type: Number, required: true, default: 1 }, // 模块类型 0.我的客户  1.本组客户  2.客户公海  3.客户回收站
    showSourceType: { type: Boolean, required: false, default: true } // 是否显示客户来源
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      CrmCustomerConstants,
      crmCustomerTypeList: [],
      customerContactChannelList: [],
      quotationClient: new QuotationClient().fillDefaultValue().getData(),
      txtOwnerId: '', // 销售
      txtBranchId: '', // 所属分公司
      txtDepartment: '', // 所属部门
      txtGroupLeader: '', // 组长
      tianYanChaUrl: 'https://www.tianyancha.com/search?key=',
      customerLevelCode: [],
      overcomeLevelCode: []
    }
  },

  computed: {
    readonly() {
      return !this.isEditing
    },
    isEditing() {
      return this.action !== 'look'
    }
  },
  watch: {
    'quotationClient.name': {
      handler(newVal) {
        const name = newVal
        this.tianYanChaUrl = 'https://www.tianyancha.com/search?key='
        if (name) {
          this.tianYanChaUrl += encodeURIComponent(name)
        }
      }
    }
  },
  created() {
  },
  mounted() {
    this.initData()
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh && this.isEditing) return
      this.loading = getLoading()
      this.quotationClient = { ...row }
      await this.display()
      this.loading.close()
    },
    async display() {
      this.txtOwnerId = '' // 销售
      this.txtBranchId = '' // 所属分公司
      this.txtDepartment = '' // 所属部门
      this.txtGroupLeader = '' // 组长
      this.crmCustomerTypeList = [] // 客户类型
      this.customerContactChannelList = [] // 客户接触渠道
      if (!this.quotationClient) return
      // 初次接触日期默认为今天
      if (!this.quotationClient.firstMeetDate && this.action === 'add') {
        this.quotationClient.firstMeetDate = new Date()
      }
      if (this.quotationClient.ownerId && this.quotationClient.ownerId > 0) {
        const user = await User.getUserById(this.quotationClient.ownerId)
        if (user) {
          // 销售
          this.txtOwnerId = this.$store.getters.language === 'zh' ? user.chineseName : user.englishName
          // 所属公司
          let officeId = user.defaultOfficeId
          if (!officeId || officeId <= 0) {
            officeId = this.quotationClient.branchId
          }
          if (officeId && officeId > 0) {
            const office = await Office.getOfficeById(officeId)
            if (office) {
              this.txtBranchId = this.$store.getters.language === 'zh' ? office.chineseName : office.englishName
            }
          }
        }
      }
      // 所属部门
      if (this.quotationClient.departmentId && this.quotationClient.departmentId > 0) {
        const arr = getCacheListByKey(basicCacheKeys.basic_data_Department_All)
        if (arr && arr.length > 0) {
          for (const dep of arr) {
            if (dep.departmentId === this.quotationClient.departmentId) {
              this.txtDepartment = this.$store.getters.language === 'zh' ? dep.chineseName : dep.englishName
              break
            }
          }
        }
      }
      // 组长
      if (this.quotationClient.groupLeaderId && this.quotationClient.groupLeaderId > 0) {
        const user = await User.getUserById(this.quotationClient.groupLeaderId)
        if (user) {
          this.txtGroupLeader = this.$store.getters.language === 'zh' ? user.chineseName : user.englishName
        }
      }
      // 如果销售为空则沉睡天数 = 即将到期天数
      if (!this.quotationClient.ownerId || this.quotationClient.ownerId <= 0) {
        this.quotationClient.dueTime2 = this.quotationClient.sleepDays
      }
      if (this.quotationClient.uuid) {
        this.quotationClient.companyTypeCode = parseInt(this.quotationClient.companyTypeCode) || 0
        this.quotationClient.customerLevelCode = parseInt(this.quotationClient.customerLevelCode) || 0
        this.quotationClient.overcomeLevelCode = parseInt(this.quotationClient.overcomeLevelCode) || 0
      }
      this.quotationClient.customerStatusCode = parseInt(this.quotationClient.customerStatusCode) === -1 ? 0 : parseInt(this.quotationClient.customerStatusCode)// 初始化时默认为潜在阶段
      // 客户接触渠道默认为公司官网
      if (parseInt(this.quotationClient.customerContactChannel) === 0 && this.action === 'add') {
        this.quotationClient.customerContactChannel = 1
      }
      // 客户类型 CARGO-25396 客户类型、客户接触渠道改为基础数据维护
      // 初始化客户类型
      this.crmCustomerTypeList = CrmCustomerConstants.CUSTOMER_TYPE
      this.crmCustomerTypeList = this.crmCustomerTypeList.concat(getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CrmCustomerType))
      // 初始化客户接触渠道
      this.customerContactChannelList = CrmCustomerConstants.CUSTOMER_CONTACT_CHANNEL_GRID
      this.customerContactChannelList = this.customerContactChannelList.concat(getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CustomerContactChannel))
    },
    // 保存
    getSubmitData() {
      this.validateForm()
      return {
        quotationClient: this.quotationClient
      }
    },
    selectCargoItem(item) {
      this.quotationClient.country = item.value
    },
    validateForm() {
      if (!this.quotationClient.name || !this.quotationClient.name.trim()) {
        throw new TabError(this.$t('CargoMsg.Cargo_ChineseNameCanTBeEmpty'), 'tabCrmCustomer')
      }
      if (!this.quotationClient.englishName || !this.quotationClient.englishName.trim()) {
        throw new TabError(this.$t('CargoMsg.Cargo_EnglishNameCanTBeEmpty'), 'tabCrmCustomer')
      }
      if (!this.quotationClient.firstMeetDate) {
        throw new TabError(this.$t('Message.FirstDateCannotBeBlank'), 'tabCrmCustomer')
      }

      if (!this.quotationClient.address || !this.quotationClient.address.trim()) {
        throw new TabError(this.$t('CargoMsg.Cargo_StreetAddressCanTBeEmpty'), 'tabCrmCustomer')
      }
    },
    // 获取初始化数据
    initData() {
      getMyCustomerSelectType().then(res => {
        if (res.code === '0') {
          this.customerLevelCode = res.data.customerLevelList
          this.overcomeLevelCode = res.data.difficultyList
        }
      }).catch()
    }
  }
}
</script>

<style scoped type="text/css">
</style>
